<app-header></app-header>
<!-- <app-banner-enquiry-form></app-banner-enquiry-form> -->
<app-banner-enquiry-form [backgroundImageId]="'3'"[loanTypeId]="15"  serviceName="children education planning"></app-banner-enquiry-form>

<!-- Hero Section with Get In Touch Form -->
<!-- <section class="form-section">
 
  <div class="row d-flex justify-content-center align-items-center" style="height: 100vh;">
    <div class="col-md-7">
        <div class="card transparent-card">
            <h1>We help you to Achieve your Financial Goals</h1>
            <a href="/appointment" class="btn btn-orange small-button ">Schedule a Meeting</a>
        </div>
    </div>


    <div class="col-md-5">
      <div class="form-container">
        <h2>GET IN TOUCH</h2>
        <h3 class="slogan">Your journey to financial freedom starts here!</h3>
        <form [formGroup]="enquiryForm" (ngSubmit)="onSubmit()">
          <input type="text" formControlName="full_name" placeholder="Enter your Name" required>
          <input type="email" formControlName="email" placeholder="Enter your Email" required>
          <input type="tel" formControlName="phone" placeholder="Enter Phone Number" required>
          <input type="text" formControlName="enq_detail_msg" placeholder="Enter your Message" required>
          <button type="submit" [disabled]="!enquiryForm.valid">Submit</button>
        </form>
      </div>
    </div>
</div>
    

  
</section> -->
    

  
  <!-- <div class="form-container">

  
   
  </div> -->


  <!-- <div class="row">
    <div class="col-md-7">
      <h1 style="color: whitesmoke;">We help you to Achieve your Financial Goals</h1>
  <button class="schedule-button">Schedule a Meeting</button>
    </div>
    <div class="col-md-5">

      <h2>GET IN TOUCH</h2>
      <h3>Your journey to financial freedom starts here!</h3>
      <form>
        <input type="text" placeholder="Enter your Name" required>
        <input type="email" placeholder="Enter your Email" required>
        <input type="tel" placeholder="Enter Phone Number" required>
        <input type="text" placeholder="Enter your Message" required>
        <button type="submit">Submit</button>
      </form>
    </div>
  </div> -->
<!-- </section> -->

<div class="plan-section">
  <h2 class="plan-title">Children Education Planning</h2>
  <p class="plan-description">
    As a parent, you want nothing but the best for your child. Education is one of the most important investments you can make in your child's future. At SNP Money, we understand the importance of planning for your child's education and its financial implications on your family. That's why we offer comprehensive Children's Education Planning services to help you achieve your education savings goals.  </p>

  <h3 class="important-heading">
    Why is Children's Education Planning Important?
    <div class="underline"></div>
  </h3>
  <p class="plan-description">
    Education is one of the most significant expenses that a family will face. The costs can be substantial whether you're planning for your child's primary, secondary, or higher education. By planning, you can ensure that your child has access to the best educational opportunities without compromising your financial stability.  </p>
  





  

<!-- How We Can Help Section -->
<section class="service-section">
  <!-- Text Content -->
  <div class="content order-md-1 order-2">
    <h2>How We Can Help</h2>
    <p>
      At SNP Money, we understand that every family's needs are unique. We offer personalized Children's Education Planning services tailored to your goals and circumstances. Our team of financial experts will work closely with you to develop a comprehensive plan that takes into account factors such as:
    </p>
    <p>  
           <ul>  <p>
      <li>Your child's educational goals and aspirations</li>
      <li>The cost of education at different institutions and levels</li>
      <li>Your current financial situation and future earning potential</li>
      <li>Tax implications and potential savings opportunities</li>
      <li>Investment strategies to help grow your education fund over time</li>
        </p></ul>
  
  </div>

  <!-- Image -->
  <div class="order-md-2 order-1">
    <img src="assets/cp/21315040_readbook_1.jpg" alt="Setting Financial Goals">
  </div>
</section>


  <section class="service-section">
    <img src="assets\cp\businesstraining_11.jpg" alt="Developing a Financial Plan">
    <div class="content">
      <h2>Our Approach
    </h2>
      <p>
        Our approach to Children Education Planning is centered around three key principles:
        <strong>Education Goals:</strong> We start by understanding your child's educational goals and aspirations. Whether they dream of attending a prestigious university or pursuing a specialized career, we'll help you create a plan that aligns with their ambitions. <br>
        <strong>Financial Analysis:</strong> We'll conduct a thorough analysis of your financial situation to determine how much you need to save for your child's education. This includes considering factors such as inflation, potential scholarships or financial aid, and the impact of other financial goals, such as retirement planning. <br>
         <strong> Customized Solutions: </strong> Based on our analysis, we'll recommend a customized solution that meets your family's needs. This may include setting up a dedicated education <strong>savings account,</strong>  investing in tax-efficient instruments, or exploring other creative strategies to maximize your savings potential.
              </p>
    </div>
  </section>

  <!-- Why Choose Us Section -->
<section class="service-section">
  <!-- Text Content -->
  <div class="content order-md-1 order-2">
    <h2>Why Choose Us?</h2>
    <p>
      SNP Money has a proven track record of helping families like yours achieve their education savings goals. Our team of experts has the knowledge and experience to guide you through the complexities of Child Education Planning, ensuring that you have a solid plan in place to secure your child's future.
    </p>
  </div>

  <!-- Image -->
  <div class="order-md-2 order-1">
    <img src="assets/cp/19197680_schedule_3.jpg" alt="Monitoring and Adjusting">
  </div>
</section>

</div>


<section class="contact-us-section">
  <div class="contact-content">
    <h2>Contact Us  Today!</h2>
    <p class="slogan">Your journey to financial freedom starts here!</p>
  </div>

  <div class="contact-form-container"> 
    <form [formGroup]="enquiryForm" (ngSubmit)="onSubmit()" class="contact-form">
      <h2>Submit Your Enquiry</h2>
      <input formControlName="full_name" type="text" placeholder="Your Name" required>
      <input formControlName="email" type="email" placeholder="Your Email" required>
      <input formControlName="phone" type="tel" placeholder="Your Phone Number" required>
      <input type="datetime-local" formControlName="appointment_date" id="appointmentDate" required>
      <textarea formControlName="enq_detail_msg" placeholder="Your Message" required></textarea>
      <button type="submit" [disabled]="enquiryForm.invalid">Send Message</button>
    </form>
  
    <!-- Standard message after submission -->

  <!-- Thank you message with animated smiley -->
  <div *ngIf="isEnquirySubmitted" class="thank-you-message animated">
    <h3>
      Thank you for your enquiry! We will get back to you shortly! 
      <span class="smiley">😊</span>
    </h3>
  </div>
  </div>
  
</section>


<app-footer></app-footer>
